<template>
  <b-row class= 'box my-3'>
    <b-col cols=2 class='' style='padding: 0px 0px 0px 0px;'>
      <div class='icon'>
        <div class='wraper'>
          <component
            :is='asset.component'
            v-bind='asset.properties'
          />
        </div>
      </div>
    </b-col>
    <b-col cols=10 class=''>
        <b-row>
            <b-col cols=4 class='pr-0'>
                <h5 class='key'> {{asset.symbol}}</h5>
            </b-col>
            <b-col cols=8 class='pl-0'>
                <h5 class='text-right value'> {{asset.value}}</h5>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols=8>
                <p class='name'> {{asset.name}}</p>
            </b-col>
            <b-col cols=4>
                <h5 class='text-right price'> {{asset.price}} $</h5>
            </b-col>
        </b-row>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: [
    'asset'
  ]
}
</script>

<style scoped>
    .box .icon{
      display: table;
      height: 37px;
      width: 37px;
      margin: auto;
      border-radius: 25px;
    }
    .box .icon .wraper{
      display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
    .box .key {
        margin-bottom: 0px;
        font-family: "Poppins-Light";
        font-style: normal;
        font-weight: bold;
        /*font-size: 12px;
        line-height: 18px;*/
        color: #FFF9BC;
    }
    .box .name {
        margin-bottom: 0px;
        font-family: "Poppins-Light";
        font-style: normal;
        font-size: 13px;
        line-height: 18px;
        color: #FFF9BC;
    }
    .box .value {
      font-style: normal;
      /*font-weight: bold;*/
      color: #FFF;
      margin-bottom: 0px;
    }

    .box .price{
        font-family: "Poppins-Light";
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 0px;
        color: #A7A4A4;
    }
    .box .icon{
        background-color: #323232 !important;
    }
</style>
